import { Modal } from 'antd';

import ObjectForm, { OBJECT_FORM_MODE, newObjectTitle } from '@components/forms/ObjectForm';

import TrainObjectModal from './TrainObjectModal';

/**
 * Both steps of Train New Object, driven by `useTrainNewObject`'s `modals`: the
 * training-data modal, then the create form (`ObjectForm`, with its own buttons; the
 * dialog carries its title) for a new object trained from the active one.
 *
 * @param {object} props - `useTrainNewObject().modals`
 */
const TrainNewObjectModals = ({
	content,
	trainOpen,
	createOpen,
	parent,
	projectMode,
	canSave,
	createDisabledReason,
	creating,
	onClose,
	onSave,
	onCreate,
	onSubmit,
}) => (
	<>
		<TrainObjectModal
			open={trainOpen}
			content={content}
			onClose={onClose}
			onSave={onSave}
			canSave={canSave}
			onCreate={onCreate}
			createDisabledReason={createDisabledReason}
		/>
		<Modal
			open={createOpen}
			// The dialog's title names it; the form leaves its own out.
			title={parent ? newObjectTitle(parent.name) : null}
			onCancel={onClose}
			footer={null}
			mask={{ closable: false }}
			destroyOnHidden>
			{/* antd applies initialValues on mount only: one form per parent. */}
			{parent && (
				<ObjectForm
					key={parent.uuid}
					mode={OBJECT_FORM_MODE.CREATE}
					showTitle={false}
					object={parent}
					projectMode={projectMode}
					loading={creating}
					onSubmit={onSubmit}
					onCancel={onClose}
				/>
			)}
		</Modal>
	</>
);

export default TrainNewObjectModals;
